module.exports = __webpack_public_path__ + "img/downchevoron.8762f50f.svg";